export enum StudyStoreState {
	CREATED = 'created',
	PENDING = 'pending',
	CALCULATED = 'calculated',
	FAILED = 'failed',
	READY = 'ready',
}
